// Static imports (critical LCP)
import HeroV2 from 'components/landing-pages-v2/HeroV2';
import HeroV2WithMarkers from 'components/landing-pages-v2/HeroV2WithMarkers';

import { dynamicEntry } from './dynamicEntry';
import IEntryLookup from './entries';

// Dynamic imports
const ExternalLinks = dynamicEntry(() => import('components/articles-v2/ExternalLinks'));
const BasicPageHeader = dynamicEntry(() => import('components/landing-pages-v2/BasicPageHeader'));
const Calculator = dynamicEntry(() => import('components/landing-pages-v2/Calculator'));
const CarouselCards = dynamicEntry(
  () => import('components/landing-pages-v2/CarouselSection/CarouselCards'),
);
const ComparisonTable = dynamicEntry(() => import('components/landing-pages-v2/ComparisonTable'));
const ContactSection = dynamicEntry(() => import('components/landing-pages-v2/ContactSection'));
// import CountdownTimer from 'components/landing-pages-v2/CountdownTimer';
const CTAStandalone = dynamicEntry(() => import('components/landing-pages-v2/CTAStandalone'));
const FAQsDisplay = dynamicEntry(() => import('components/landing-pages-v2/FAQsDisplay'));
const Feature5050 = dynamicEntry(() => import('components/landing-pages-v2/Feature5050'));
const HeaderStandalone = dynamicEntry(() => import('components/landing-pages-v2/HeaderStandalone'));
const HeroCTA = dynamicEntry(() => import('components/landing-pages-v2/HeroCTA'));
const ImageCard = dynamicEntry(() => import('components/landing-pages-v2/ImageCard'));
const LinkList = dynamicEntry(() => import('components/landing-pages-v2/LinkList'));
const List = dynamicEntry(() => import('components/landing-pages-v2/List'));
const LWCHeroCard = dynamicEntry(() => import('components/landing-pages-v2/LWCHeroCard'));
const LWCImageCard = dynamicEntry(() => import('components/landing-pages-v2/LWCImageCard'));
const LWCTextSection = dynamicEntry(() => import('components/landing-pages-v2/LWCTextSection'));
const MapBackgroundHero = dynamicEntry(
  () => import('components/landing-pages-v2/MapBackgroundHero'),
);
const MarketStats = dynamicEntry(() => import('components/landing-pages-v2/MarketStats'));
const Multicard = dynamicEntry(() => import('components/landing-pages-v2/Multicard'));
const OpenPositions = dynamicEntry(() => import('components/landing-pages-v2/OpenPositions'));
const OptionsComparison = dynamicEntry(
  () => import('components/landing-pages-v2/OptionsComparison'),
);
const Quotation = dynamicEntry(() => import('components/landing-pages-v2/Quotation'));
const Reviews = dynamicEntry(() => import('components/landing-pages-v2/reviews'));
const Spacer = dynamicEntry(() => import('components/landing-pages-v2/Spacer'));
const StandaloneText = dynamicEntry(() => import('components/landing-pages-v2/StandaloneText'));
const TimeSavingsCalculator = dynamicEntry(
  () => import('components/landing-pages-v2/TimeSavingsCalculator'),
);
const VideoPlayer = dynamicEntry(() => import('components/landing-pages-v2/VideoPlayer'));
const TrustpilotWidget = dynamicEntry(() => import('components/shared/TrustpilotWidget'));
const FCHero = dynamicEntry(() => import('components/landing-pages-v2/FCHero'));
const FCTrustBanner = dynamicEntry(() => import('components/landing-pages-v2/FCTrustBanner'));
const FCValueTracker = dynamicEntry(() => import('components/landing-pages-v2/FCValueTracker'));
const FCThreeSteps = dynamicEntry(() => import('components/landing-pages-v2/FCThreeSteps'));
const FCProductOptions = dynamicEntry(() => import('components/landing-pages-v2/FCProductOptions'));
const FCTestimonialCarousel = dynamicEntry(
  () => import('components/landing-pages-v2/FCTestimonialCarousel'),
);
const FCMap = dynamicEntry(() => import('components/landing-pages-v2/FCMap'));
const FCMissionStatement = dynamicEntry(
  () => import('components/landing-pages-v2/FCMissionStatement'),
);
const FCContactUs = dynamicEntry(() => import('components/landing-pages-v2/FCContactUs'));
const TextBanner = dynamicEntry(() => import('components/landing-pages-v2/TextBanner'));
const CustomBlock = dynamicEntry(() => import('components/landing-pages-v2/CustomBlock'));

const landingPageV2EntryLookup: IEntryLookup = {
  block: {
    lpComponentMapBackgroundHero: MapBackgroundHero,
    lpComponentCarouselCards: CarouselCards,
    lpComponentImageCard: ImageCard,
    lpComponentFaqDisplay: FAQsDisplay,
    lpComponentHeroV2: HeroV2,
    lpComponentContactSection: ContactSection,
    lpComponentLwcTextSection: LWCTextSection,
    lpComponentLwcHeroCard: LWCHeroCard,
    lpComponentLwcImageCard: LWCImageCard,
    lpComponentHeroV2WithMarkers: HeroV2WithMarkers,
    lpComponentCTAStandalone: CTAStandalone,
    lpComponentComparisonTable: ComparisonTable,
    lpComponentFeature5050: Feature5050,
    lpComponentHeaderStandalone: HeaderStandalone,
    lpComponentHeroCta: HeroCTA,
    lpComponentList: List,
    lpComponentStandaloneText: StandaloneText,
    lpComponentMulticard: Multicard,
    lpComponentBasicPageHeader: BasicPageHeader,
    lpComponentLinkList: LinkList,
    lpComponentQuotation: Quotation,
    lpComponentSpacer: Spacer,
    lpComponentOpenPositions: OpenPositions,
    lpComponentOptionsComparison: OptionsComparison,
    lpComponentOpendoorReviews: Reviews,
    lpComponentCalculator: Calculator,
    lpComponentTimeSavingsCalculator: TimeSavingsCalculator,
    // lpComponentCountdownTimer: CountdownTimer,
    lpComponentVideoPlayer: VideoPlayer,
    lpComponentMarketStats: MarketStats,
    trustpilotWidget: TrustpilotWidget,
    componentRelatedExternalLinks: ExternalLinks,
    fcHero: FCHero,
    fcTrustBanner: FCTrustBanner,
    fcValueTracker: FCValueTracker,
    fcThreeSteps: FCThreeSteps,
    fcProductOptions: FCProductOptions,
    fcTestimonialCarousel: FCTestimonialCarousel,
    fcMap: FCMap,
    fcMissionStatement: FCMissionStatement,
    fcContactUs: FCContactUs,
    lpComponentTextBanner: TextBanner,
    lpComponentCustomBlock: CustomBlock,
  },
  inline: {},
};

export default landingPageV2EntryLookup;
